
import Vue from "vue";
import App from "./App";
import router from "./router";
import "./assets/css/aui-pc.css";
import "./assets/css/media.css";
import dgUI from "./components/index";
import { isIE } from "./assets/js/utils";
import ajax from "./assets/js/axios/index";
import mirror from "./assets/js/mirror.js";
import * as Sentry from "@sentry/vue";
window.ajax = ajax;
window.Mirror = mirror;
Vue.prototype.ENV = process.env;
window.config = process.config;
Vue.prototype.conf = process.config;
Vue.prototype.isIE = isIE();
Vue.use(dgUI);
Vue.config.productionTip = false;
router.beforeEach((to, from, next) => {
  // console.log(to, "to, from, next");
  let Nologin = ["login", "register", "protocolRegister", "modifyPasw", "forgetPasw"];
  if (document.cookie.indexOf("baohan-jinfu-supply-chain") == -1 && Nologin.indexOf(to.name) == -1 && to.path.indexOf("/external") == -1 && to.name.indexOf("shortLink") == -1) {
    next({ name: "login" });
  } else {
    next();
  }
});

/**
 * 动态引入js
 * @param {*} src
 */
const injectScript = (srcs, callback) => {
  const loadNextScript = (index) => {
    if (index >= srcs.length) {
      // 所有 src 都加载失败
      console.error("所有脚本加载失败");
      return;
    }
    const s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = srcs[index];
    const t = document.getElementsByTagName("script")[0];
    t.parentNode.insertBefore(s, t);
    s.onload = function () {
      // 当前脚本加载成功，调用回调函数
      callback && callback();
    };

    s.onerror = function () {
      // 当前脚本加载失败，尝试加载下一个脚本
      console.error(`脚本 ${srcs[index]} 加载失败，尝试加载下一个`);
      loadNextScript(index + 1);
    };
  };

  // 开始加载第一个脚本
  loadNextScript(0);
};
window.Vue = Vue;
let element_host = ['/static/index.js']
console.log(process.config)
injectScript(element_host, () => {


  Sentry.init({
    Vue,
    dsn: "http://66d0fbcad3a821b2e87d72aaa823af0d@10.10.112.64:9000/6",
    integrations: [
      Sentry.browserTracingIntegration({ router })
    ],
    // Tracing
    tracesSampleRate: 1.0, // Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: []
    // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/]
  });

  new Vue({
    router,
    render: h => h(App),
  }).$mount('#app')

});
